import { Grid, Paper, Typography } from '@mui/material';
import { Theme, SystemStyleObject } from '@mui/system';
import useGetContragentTypes from '~/modules/identification/hooks/useGetContragentTypes';
import { styles } from '../styles';
import { FormCheckbox } from '~/components/FormComponents/FormCheckbox';
import { FormInput } from '~/components/FormComponents/FormInput';
import { useFieldArray, useFormContext } from 'react-hook-form';
import { SecuritiesOperations } from '~/modules/identification/forms/BusinessRelations/components/SecuritiesOperations/SecuritiesOperations.tsx';
import FormGridItem from '~/components/FormComponents/FormGridItem';
import { commonStyles } from '~/theme/styles/commonStyles';

export const ClientServices = () => {
  const { isSoleTrader } = useGetContragentTypes();
  const { trigger, control, setValue, clearErrors } = useFormContext();
  const { replace: replaceTradingInfo } = useFieldArray({
    control,
    name: 'tradingInfoContacts',
  });
  const { replace: replaceDepositoryInfo } = useFieldArray({
    control,
    name: 'depositoryInfoContacts',
  });
  const checkValidation = () => {
    trigger('other');
  };

  const handleCheckSecuritiesOperations = (isChecked: boolean) => {
    checkValidation();
    const value = isChecked ? null : false;
    setValue('isTradingInfoOnCapitalMarketsProvided', value);
    setValue('isDepositoryInfoOnCapitalMarketsProvided', value);
    if (!isChecked) {
      replaceTradingInfo([]);
      replaceDepositoryInfo([]);
      clearErrors('tradingInfoContacts');
      clearErrors('depositoryInfoContacts');
    }
  };

  return (
    <Paper sx={styles.paperContainer}>
      <Grid container spacing={2} sx={{ width: '100%' }}>
        <FormGridItem>
          <FormCheckbox
            label="Розрахунково-касове обслуговування"
            name="cashManagement"
            onChange={checkValidation}
          />
        </FormGridItem>
        <FormGridItem>
          <FormCheckbox label="Кредити" name="loans" onChange={checkValidation} />
        </FormGridItem>
        <FormGridItem>
          <FormCheckbox label="Депозити" name="deposits" onChange={checkValidation} />
        </FormGridItem>
        <FormGridItem>
          <FormCheckbox
            label="Торговельне фінансування та документарні операції"
            name="tradeFinanceAndDocumentaryOperations"
            onChange={checkValidation}
          />
        </FormGridItem>
        <FormGridItem>
          <FormCheckbox
            label="Операції з цінними паперами"
            name="securitiesOperations"
            onChange={handleCheckSecuritiesOperations}
          />
        </FormGridItem>
        {!isSoleTrader && <SecuritiesOperations />}
        {isSoleTrader && (
          <FormGridItem>
            <FormCheckbox label="Платіжні картки" name="paymentCards" onChange={checkValidation} />
          </FormGridItem>
        )}
        <Grid size={12} sx={commonStyles.centerFlexContainer}>
          <Typography
            sx={[
              styles.title as SystemStyleObject<Theme>,
              { display: 'inline-block', pb: '14px', flexShrink: 0 },
            ]}
            noWrap
          >
            Інше (зазначте):
          </Typography>
          <FormInput name="other" variant="outlined" fullWidth />
        </Grid>
      </Grid>
    </Paper>
  );
};
